import { Component, OnInit } from '@angular/core';
import { GenericForm, GenericFormField } from '../../../../models/GenericCRUD/GenericForm';
import { GenericTable, GenericTableAction, GenericTableColumn } from '../../../../models/GenericCRUD/GenericTable';
import { Filter } from '../../../../models/GenericCRUD/Filter';
import { GenericCRUD } from '../../../../models/GenericCRUD/GenericCRUD';
import { Paginator } from '../../../../models/Paginator';
import { GenericCrudComponent } from '../../../../shared/components/generic-crud/generic-crud.component';
import { User } from '../../../../models/User';
import { NgClass, NgIf } from '@angular/common';
import { AuthStateService } from '../../../../core/states/auth-state.service';

type UserTab = 'student' | 'employee';

@Component({
  selector: 'app-users-home',
  standalone: true,
  imports: [GenericCrudComponent, NgClass, NgIf],
  templateUrl: './users-home.component.html',
  styleUrl: './users-home.component.css'
})
export class UsersHomeComponent implements OnInit {

  isAdmin = false;
  isTeacher = false;
  activeTab: UserTab = 'student';
  formActive = false;

  // Colores de badge por nombre de rol (ya traducido por el backend)
  private roleColors: Record<string, string> = {
    'Alumno': 'bg-green-100 text-green-800',
    'Profesor': 'bg-blue-100 text-blue-800',
    'Administrador': 'bg-purple-100 text-purple-800',
    'Director': 'bg-indigo-100 text-indigo-800',
    'Responsable': 'bg-amber-100 text-amber-800',
    'Cliente Empresa': 'bg-teal-100 text-teal-800',
    'Operadora': 'bg-pink-100 text-pink-800',
  };

    tableColums: GenericTableColumn[] = [
    { name: 'ID', active: false, type: 'text', key: 'id', sort: true },
    { name: 'Nombre', active: true, type: 'text', key: 'full_name', sort: true },
    { name: 'Estado', active: false, type: 'text', key: 'current_state.name', sort: false },
    { name: 'Email', active: true, type: 'text', key: 'email', sort: true },
    { name: 'Roles', active: true, type: 'badges', key: 'roles', sort: false, colorMap: this.roleColors },
    { name: 'Carnets', active: true, type: 'array', key: 'carnets', sort: false },
    { name: 'Fecha creación', active: false, type: 'date', key: 'created_at', sort: true, format:'dd/MM/yyyy HH:mm:ss' },
    { name: 'Fecha modificación', active: false, type: 'date', key: 'updated_at', sort: true, format:'dd/MM/yyyy HH:mm:ss' },
  ];

  formFields: GenericFormField[] = [
    { name: 'name', type: 'text', label: 'Nombre', validations: 'required', placeholder: 'Ej. María' },
    { name: 'surname', type: 'text', label: 'Apellidos', validations: 'nullable', placeholder: 'Ej. García López' },
    { name: 'email', type: 'email', label: 'Email', validations: 'required', placeholder: 'ejemplo@correo.com' },
    { name: 'password', type: 'password', label: 'Contraseña', validations: 'required', placeholder: 'Mínimo 6 caracteres' },
    { name: 'nif', type: 'text', label: 'NIF/DNI', validations: 'nullable', placeholder: 'Ej. 12345678A' },
    { name: 'phone', type: 'text', label: 'Teléfono', validations: 'nullable', placeholder: 'Ej. 600123456' },
    { name: 'address', type: 'text', label: 'Calle', validations: 'nullable', placeholder: 'Ej. Calle Mayor' },
    { name: 'address_number', type: 'text', label: 'Número', validations: 'nullable', placeholder: 'Ej. 12' },
    { name: 'city', type: 'text', label: 'Localidad', validations: 'nullable', placeholder: 'Ej. Alicante' },
    { name: 'province', type: 'text', label: 'Provincia', validations: 'nullable', placeholder: 'Ej. Alicante' },
    { name: 'postal_code', type: 'text', label: 'Código Postal', validations: 'nullable', placeholder: 'Ej. 03001' },
    { name: 'rol_ids', type: 'select', label: 'Roles', validations: 'required', url: '/role/listAll', singleSelection: false },
    { name: 'office_id', type: 'select', label: 'Sucursal', validations: 'required', url: '/config/office/listAll', singleSelection: true }
  ];

  formFieldsEdit: GenericFormField[] = [
    { name: 'name', type: 'text', label: 'Nombre', validations: 'required', placeholder: 'Ej. María' },
    { name: 'surname', type: 'text', label: 'Apellidos', validations: 'nullable', placeholder: 'Ej. García López' },
    { name: 'email', type: 'email', label: 'Email', validations: 'required|email', placeholder: 'ejemplo@correo.com' },
    { name: 'password', type: 'password', label: ' Nueva Contraseña', validations: 'nullable', placeholder: 'Dejar vacío para no cambiar' },
    { name: 'nif', type: 'text', label: 'NIF/DNI', validations: 'nullable', placeholder: 'Ej. 12345678A' },
    { name: 'phone', type: 'text', label: 'Teléfono', validations: 'nullable', placeholder: 'Ej. 600123456' },
    { name: 'address', type: 'text', label: 'Calle', validations: 'nullable', placeholder: 'Ej. Calle Mayor' },
    { name: 'address_number', type: 'text', label: 'Número', validations: 'nullable', placeholder: 'Ej. 12' },
    { name: 'city', type: 'text', label: 'Localidad', validations: 'nullable', placeholder: 'Ej. Alicante' },
    { name: 'province', type: 'text', label: 'Provincia', validations: 'nullable', placeholder: 'Ej. Alicante' },
    { name: 'postal_code', type: 'text', label: 'Código Postal', validations: 'nullable', placeholder: 'Ej. 03001' },
    { name: 'rol_ids', type: 'select', label: 'Roles', validations: 'required', url: '/role/listAll', singleSelection: false },
    { name: 'office_id', type: 'select', label: 'Sucursal', validations: 'required', url: '/config/office/listAll', singleSelection: true }
  ];

  form: GenericForm = {
    successTitle: 'Creación correcta',
    errorTitle: 'Error en la creación',
    method: 'POST',
    fields: this.formFields,
    name: 'usuario',
    createButtonTitle: 'Nuevo usuario',
    cols: 2,
    createApiSlug: '/user/store',
    formTitle: 'Crear usuario',
    formButtonTitle: 'Crear usuario',
    width: '3xl'
  }

  tableActions: GenericTableAction[] = [
    {
      name: 'Editar',
      key: 'edit',
      form: {
        method: 'PUT',
        successTitle: 'Edición correcta',
        errorTitle: 'Error en la edición',
        fields: this.formFieldsEdit,
        name: 'usuario',
        createButtonTitle: '',
        cols: 2,
        createApiSlug: '',
        originalUpdateApiSlug: '/user/update/{{id}}',
        updateApiSlug: '',
        originalFormTitle: 'Editar {{name}}',
        formTitle: '',
        formButtonTitle: 'Editar',
        width: '3xl'
      },
      completeForm: true,
      replaceAllRowOnResponse: true,
      icon: '<svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-dark" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" /><path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" /><path d="M16 5l3 3" /></svg>',
      confirmation: false
    },
    {
      name: 'Eliminar',
      key: 'delete',
      method: 'DELETE',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 7l16 0" /><path d="M10 11l0 6" /><path d="M14 11l0 6" /><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" /><path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" /></svg>',
      confirmation: true,
      questionText: '¿Desea eliminar este usuario?',
      deleteRowOnResponse: true,
      actionSlug: '/user/delete/{{id}}'
    }
  ]

  genericCRUD!: GenericCRUD<Paginator<User>>;

  constructor(private authState: AuthStateService) {}

  ngOnInit(): void {
    const user = this.authState.currentUserValue;
    this.isAdmin = !!(user?.roles?.includes('admin')) ||
      (Array.isArray(user?.profile?.roles) && (user!.profile.roles as any[]).some(r => r.name === 'admin')) ||
      (user as any)?.profile?.roles?.name === 'admin';

    const isOperator = !!(user?.roles?.includes('operator')) ||
      (Array.isArray(user?.profile?.roles) && (user!.profile.roles as any[]).some(r => r.name === 'operator'));

    this.isTeacher = !!(user?.roles?.includes('teacher')) ||
      (Array.isArray(user?.profile?.roles) && (user!.profile.roles as any[]).some(r => r.name === 'teacher'));

    // Operadora: la sucursal se asigna automáticamente al crear (campo oculto),
    // y en edición se muestra bloqueada.
    if (isOperator) {
      this.removeField(this.formFields, 'office_id');
      const editOffice = this.formFieldsEdit.find(f => f.name === 'office_id');
      if (editOffice) editOffice.disabled = true;
    }

    this.setTab('student');
  }

  private removeField(fields: GenericFormField[], name: string): void {
    const i = fields.findIndex(f => f.name === name);
    if (i !== -1) fields.splice(i, 1);
  }

  // Copia de los campos sin uno dado (no muta el original).
  private fieldsWithout(fields: GenericFormField[], name: string): GenericFormField[] {
    return fields.filter(f => f.name !== name);
  }

  setTab(tab: UserTab): void {
    if (!this.isAdmin) tab = 'student';
    this.activeTab = tab;
    this.genericCRUD = this.buildCrud(tab);
  }

  private buildCrud(tab: UserTab): GenericCRUD<Paginator<User>> {
    const table: GenericTable<Paginator<User>> = {
      // En alumnos no tiene sentido la columna de Roles (todos son alumnos).
      columns: tab === 'student' ? this.tableColums.filter(c => c.name !== 'Roles') : this.tableColums,
      items: [],
      type: 'generic',
      loadItemsSlug: `/user/list?user_type=${tab}`,
      paginate: true,
      name: 'usuarios',
      actions: this.tableActions,
      details: true,
    };

    // El filtro de Rol solo tiene sentido en empleados (en alumnos todos son alumnos).
    const filters: Filter[] = [
      { type: 'search', key: 'name|email', operator: 'like', placeholder: 'Nombre o email' },
    ];
    if (tab === 'employee') {
      filters.push({ type: 'select', key: 'rol_id', operator: '=', placeholder: 'Rol', url: `/role/listAll?type=${tab}` });
    }

    // En la pestaña de Alumnos el rol se asigna automáticamente (student): sin selector.
    // El multiselect de roles solo en Empleados.
    const isStudentTab = tab === 'student';
    this.form.fields = isStudentTab ? this.fieldsWithout(this.formFields, 'rol_ids') : this.formFields;
    const editAction = this.tableActions.find(a => a.key === 'edit');
    if (editAction?.form) {
      editAction.form.fields = isStudentTab ? this.fieldsWithout(this.formFieldsEdit, 'rol_ids') : this.formFieldsEdit;
    }

    // El profesor solo consulta: ni crear, ni editar, ni eliminar usuarios.
    if (this.isTeacher) {
      table.actions = [];
    }

    return {
      genericForm: this.isTeacher ? undefined : this.form,
      genericTable: table,
      genericFilters: filters,
      useModalForm: false
    };
  }
}
